import { validateString, validationObject } from 'utils/validations';

export const initialState = {
  name: '',
  departmentId: '',
  notes: '',
};

export const initialValues = data => {
  const displayedValues = {
    ...data.generalInfo,
  };
  const initial = {};
  Object.entries(displayedValues).forEach(([key, value]) => {
    initial[key] = value.idValue ? value.idValue : value.value;
  });
  return initial;
};

export const generalSection = () => [
  {
    field: 'departmentId',
    label: 'Department ID',
    type: 'text',
    required: false,
    size: 'half',
    placeholder: 'Enter a unique department Id',
    maxLength: 250,
  },
  {
    field: 'name',
    type: 'text',
    required: true,
    size: 'half',
    placeholder: 'Enter the department name',
    maxLength: 250,
  },
  {
    field: 'notes',
    type: 'textArea',
    required: false,
    size: 'full',
    placeholder: 'Enter notes about department',
    maxLength: 1000,
  },
];

export const validationSchema = validationObject({
  name: validateString(30, true),
});
